import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagesAdminRoutingModule } from './pages-admin-routing.module';
import { InicioAdminComponent } from './inicio-admin/inicio-admin.component';
import { MatIconModule } from '@angular/material/icon';
import { SolicitudesCitasComponent } from './solicitudes-citas/solicitudes-citas.component';
import { CitasProgramadasComponent } from './citas-programadas/citas-programadas.component';
import { HistorialCitasComponent } from './historial-citas/historial-citas.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SharedModule } from '../shared/shared.module';
import { DetalleCitaAsignadaComponent } from './detalle-cita-asignada/detalle-cita-asignada.component';


@NgModule({
  declarations: [
    InicioAdminComponent,
    SolicitudesCitasComponent,
    CitasProgramadasComponent,
    HistorialCitasComponent,
    DetalleCitaAsignadaComponent
  ],
  imports: [
    CommonModule,
    PagesAdminRoutingModule,
    SharedModule,
    MatIconModule,
    MatSnackBarModule,
    SharedModule
  ]
})
export class PagesAdminModule { }
